import { domainProvider } from '@mathflat/shared/@common/domain/domainProvider'

import type { LocalStorageDataT } from '@/constant'

const isDev =
  import.meta.env.VITE_VERCEL_ENV === 'development' || import.meta.env.VITE_VERCEL_ENV === 'preview'
const isStaging = import.meta.env.VITE_VERCEL_ENV === 'staging'
const isLive = import.meta.env.VITE_VERCEL_ENV === 'production'
const currentPhase = import.meta.env.VITE_VERCEL_ENV
const isLocalDev = process.env.NODE_ENV === 'development'
const isSchool = import.meta.env.VITE_BRAND === 'schoolflat'

// CI 가 빌드 직전 .env 에 주입한다. 로컬 개발에는 없으므로 빈 문자열로 얼버무리지 않고 unknown 으로 드러낸다.
const releaseId = import.meta.env.VITE_RELEASE_ID || 'unknown'

if (!isLive) {
  console.info('env', currentPhase, 'brand', isSchool ? 'schoolflat' : 'mathflat')
}

const localStrapiApiUrl = import.meta.env.DEV
  ? import.meta.env.VITE_LOCAL_STRAPI_API_URL
  : undefined

const envStudentAppURL = import.meta.env.VITE_VERCEL_STUDENT_APP_URL

const getStudentAppURL = (env: Exclude<LocalStorageDataT['DEV_API'], 'custom'>) => {
  const brand = import.meta.env.VITE_BRAND ?? 'mathflat'

  let targetDomain = domainProvider.TARGET_DOMAIN

  if (brand !== 'mathflat') {
    targetDomain = `${brand}.com` // = schoolflat.com
  }

  if (env === 'live') {
    return `https://student.${targetDomain}`
  }
  if (env === 'stg') {
    return `https://student-staging.${targetDomain}`
  }
  return `https://student-dev.${targetDomain}`
}

const defaultStudentAppURL = (() => {
  if (envStudentAppURL) return envStudentAppURL
  return getStudentAppURL(isDev ? 'dev' : isStaging ? 'stg' : isLive ? 'live' : 'dev')
})()

const tossPaymentClientKey = import.meta.env.VITE_VERCEL_TOSS_PAYMENT_CLIENT_KEY

const getPdfClientURL = () => {
  if (isLive) {
    return `https://mathflat-pdf-client.mathflat.com`
  }
  if (isStaging) {
    return `https://mathflat-pdf-client-staging.mathflat.com`
  }
  return `https://mathflat-pdf-client-dev.mathflat.com`
}

export const envUtils = {
  isDev,
  isStaging,
  isLive,
  currentPhase,
  studentAppURL: defaultStudentAppURL,
  getStudentAppURL,
  getPdfClientURL,
  isLocalDev,
  localStrapiApiUrl,
  isSchool,
  tossPaymentClientKey,
  releaseId,
}
